// states and towns for users to select from
const TOWNS = [
  "Aba",
  "Arochukwu",
  "Umuahia",
  "Jimeta",
  "Mubi",
  "Numan",
  "Ikot Abasi",
  "Ikot Ekpene",
  "Oron",
  "Uyo",
  "Awka",
  "Onitsha",
  "Azare",
  "Bauchi",
  "Jama'are",
  "Katagum",
  "Misau",
  "Brass",
  "Makurdi",
  "Biu",
  "Dikwa",
  "Maiduguri",
  "Calabar",
  "Ogoja",
  "Asaba",
  "Burutu",
  "Koko",
  "Sapele",
  "Ughelli",
  "Warri",
  "Abakaliki",
  "Benin city",
  "Ado Ekiti",
  "Efon Alaye",
  "Ikere-Ekiti",
  "Abuja",
  "Deba Habe",
  "Gombe",
  "Kumo",
  "Owerri",
  "Birnin Kudu",
  "Dutse",
  "Gumel",
  "Hadejia",
  "Kazaure",
  "Jemaa",
  "Kaduna",
  "Zaria",
  "Kano",
  "Daura",
  "Katsina",
  "Argungu",
  "Birnin Kebbi",
  "Gwandu",
  "Yelwa",
  "Idah",
  "Kabba",
  "Lokoja",
  "Okene",
  "Ilorin",
  "Jebba",
  "Lafiagi",
  "Offa",
  "Pategi",
  "Badagry",
  "Epe",
  "Ikeja",
  "Ikorodu",
  "Lagos",
  "Mushin",
  "Shomolu",
  "Keffi",
  "Lafia",
  "Nasarawa",
  "Agale",
  "Baro",
  "Bida",
  "Kotangora",
  "Lapai",
  "Minna",
  "Suleja",
  "Abeokuta",
  "Ijebu Ode",
  "Ilaro",
  "Shagamu",
  "Akure",
  "Ikare",
  "Oka-Akoko",
  "Ondo",
  "Owo",
  "Ede",
  "Ikire",
  "Ikirun",
  "Ila",
  "Ile-Ife",
  "Ilesha",
  "Ilobu",
  "Inisa",
  "Iwo",
  "Oshogbo",
  "Ibadan",
  "Iseyin",
  "Ogbomosho",
  "Oyo",
  "Saki",
  "Bukuru",
  "Jos",
  "Vom",
  "Wase",
  "Bonny",
  "Degema",
  "Okrika",
  "Port-Harcourt",
  "Sokoto",
  "Ibi",
  "Jalingo",
  "Muri",
  "Damaturu",
  "Nguru",
  "Gusau",
  "Kaura Namoda",
];
export default TOWNS;
